export const STRINGS = {
  landing: {
    logo: 'Go To Homepage',
    title: 'Belong Rent Estimate Calculator',
    description: "Find Out Your Home's Rental Value With Accurate Rent Estimates For Maximum Rental Income",
    keywords: 'Rent Estimate, Rent Calculator, Rental Home Value, Rental Income Estimate',
    header: "Belong's Rent Estimate Calculator",
    titleOne: 'Accurate Rent Estimates For',
    titleTwo: 'Maximum',
    titleThree: 'Rental Income',
    placeholder: 'Enter Your Rental Home Address',
    placeholderUnit: 'Unit',
    cta: 'Get Rent Estimate',
    exampleMapAlt: 'Map with comparable homes',
    exampleMapAltHomeOne: 'Home with a USD 3.2K rent',
    exampleMapAltHomeTwo: 'Home with a USD 2.8K rent',
    exampleMapAltHomeThree: 'Home with a USD 2.8K rent',
    exampleMapAltHomeFour: 'Home with a USD 3.6K rent',
    exampleMapAltHomeFive: 'Home with a USD 4.1K rent',
    exampleMapAltHomeSix: 'Home with a USD 3.2K rent',
    exampleMapAltHomeSeven: 'Home with a USD 4.6K rent',
    exampleMapAltHomeEight: 'Home with a USD 3.2K rent',
    exampleMapAltHomeNine: 'Home with a USD 3.8K rent',
    exampleReportRenovationTitle: 'Renovated',
    exampleReportRenovationDescription: '+25 Years Ago',
    exampleReportPetsTitle: 'Pets',
    exampleReportPetsDescription: 'No Pets',
    exampleReportPrimaryMaterialTitle: 'Primary Material',
    exampleReportPrimaryMaterialDescription: 'Stainless Steel',
    exampleReportFeaturesTitle: 'Features',
    exampleReportFeaturesDescription: 'Pool, Parking',
    faqTitle: 'FAQs',
    faqRentalPricing: '1. How should I price my\u00a0rental?',
    faqRentalPricingAnswer:
      'To price your rental property effectively, start with our rent estimate calculator to get an accurate valuation based on local market data and comparable properties. For a detailed guide on pricing strategies and factors to consider, read our\u00a0article: [How Much Rent Should I\u00a0Charge?](/blog/how-much-rent-to-charge)',
    faqRentEstimate: '2. What is a rent estimate and how is it\u00a0calculated?',
    faqRentEstimateAnswer:
      'A rent estimate is an approximation of the rental value of a property based on various factors such as location, size, condition, and local market trends. At Belong, we use an advanced rent estimate calculator that analyzes thousands of data points, including comparable properties, recent sales, active listings, and unique features of your home, to provide the most accurate rent estimate\u00a0possible.',
    faqBelongAccuracy: "3. How accurate are Belong's rent\u00a0estimates?",
    faqBelongAccuracyAnswer:
      "Belong's rent estimates combine cutting-edge technology with local market insights. Our rental value calculator analyzes extensive neighborhood data, including recent sales and current market conditions, and adjusts for unique property features such as renovations, pet policies, and amenities. This ensures our estimates reflect the true rental value, helping you maximize your rental\u00a0income.",
    faqRentEstimateFactors: '4. What factors influence my rent\u00a0estimate?',
    faqRentEstimateFactorsAnswer:
      'Several factors influence your rent estimate, including the location, size, and condition of your property, as well as comparable properties in your neighborhood. Additional factors such as amenities, recent renovations, and current market trends also significantly determine the rental value using our rent estimate\u00a0calculator.',
    faqValueIncrease: '5. How can I increase the rental value of my\u00a0property?',
    faqValueIncreaseAnswer:
      'You can increase the rental value of your property by making improvements such as updating fixtures, adding amenities, allowing pets, and enhancing curb appeal. Also, maintaining the property in good condition and staying informed about local market trends can help maximize your rental\u00a0income.',
    faqPropertyTypes: '6. Can I get a rent estimate for different types of\u00a0properties?',
    faqPropertyTypesAnswer:
      'Yes, our rent estimate calculator is designed to provide accurate rent estimates for various property types, including single-family homes, apartments, condos, and multi-family units. By analyzing specific features and market conditions relevant to each property type, we ensure you receive a reliable estimate tailored to your unique rental\u00a0property.',
    rentalValueTitle: 'Unmatched Rental Value &\u00a0Expertise',
    rentalValueLessVacancy: 'Less Vacancy',
    rentalValueLeaseRenewal: 'Residents Renew Their\u00a0Lease',
    rentalValueDaysToLoved: 'Avg. Days To Get Homes\u00a0Loved',
    rentalValueCTA: 'Schedule A Call',
    socialProofTitle: 'Proven Rental Success',
    socialProofRentEstimatesDelivered: 'Rent Estimates Delivered',
    socialProofMembers: 'Belong Members',
    socialProofGoogle: 'Google Reviews',
    socialProofThumbtack: 'Thumbtack',
    socialProofBusinessInsider: 'Featured on BI’s 2022 Most Promising Consumer\u00a0Startups',
    socialProofBusinessInsiderLogo: 'Business Insider Logo',
    socialProofTechCrunch: '#1 of 11 Best Property Managers in San\u00a0Francisco',
    socialProofTechCrunchLogo: 'TechCrunch Logo',
    socialProofSFist: 'Included in the 2022 CB Insights Fintech 250 in the Real Estate\u00a0Category',
    socialProofSFistLogo: 'SFist Logo',
    socialProofCBInsights: '“Belong brings a full-stack approach to property\u00a0management”',
    socialProofCBInsightsLogo: 'CB Insights Logo',
    valuePropsTitle: 'What Makes Belong’s Rent Estimate Unique',
    valuePropsDataPrecisionTitle: 'Advanced Data Precision',
    valuePropsDataPrecisionDescription:
      'Our advanced algorithms analyze thousands of neighborhood data points, including crime rates, property taxes, zoning regulations, and public transport access, delivering rent estimates with unmatched\u00a0accuracy.',
    valuePropsRentalValuationTitle: 'Tailored Rental Valuation',
    valuePropsRentalValuationDescription:
      "Your rental is unique, and so is our approach. By factoring in your home's distinctive features like amenities, appliances, renovations, and pet policies, we maximize your rental income with a highly tailored\u00a0estimate.",
    valuePropsMarketIntelligenceTitle: 'Extensive Market Intelligence',
    valuePropsMarketIntelligenceDescription:
      'We go beyond surface-level data, evaluating comparable homes, rent fluctuations, and current market trends. Our analysis provides a rent estimate that truly reflects the dynamic market, ensuring you set the perfect price\u00a0confidently.',
  },
  account: {
    label: 'Account',
    question: `Hi there. I'll help you with your estimate. But first, do you have a Belong\u00a0account?`,
    yes: 'Yes',
    no: 'No',
    cta: 'Next',
    authenticationHeader: "Great, let's login!",
  },
  home: {
    label: 'Home',
    question: `Okay. Now, where is this much-loved\u00a0home?`,
    questionOutOfCoverage:
      'Belong Pro is not in {city} yet, but we can help you find tenants and self-manage with\u00a0BelongX.',
    address: 'Address',
    outOfCoverageYesLabel: 'Continue',
    outOfCoverageYesSubLabel: 'Self manage with BelongX',
    outOfCoverageYesDetail:
      'Rental home leasing & guaranteed rent for those that like to manage things\u00a0themselves.',
    outOfCoverageYesCta: 'Next',
    outOfCoverageNoLabel: 'No, Thanks!',
    outOfCoverageNoSubLabel: 'I need full management',
    outOfCoverageNoDetail: 'We’ll notify you when Belong Pro is available in\u00a0{city}.',
    outOfCoverageNoCta: 'Sounds Good',
    outOfCoverageAuthText: `Let's start by creating an account for your\u00a0home.`,
    unit: 'Unit',
    cta: 'Next',
    ctaAlternative: 'Schedule A Call',
  },
  expectation: {
    label: 'Expectation',
    question: 'Do you have an expectation of what your home should rent for?',
    yes: 'Yes!',
    yesDetail: 'I have a number in mind.',
    yesDescription: `Let's see how our estimate, utilizing current market dynamics, compares with what you had in\u00a0mind.`,
    no: 'No clue.',
    noDetail: 'Give me an idea.',
    noDescription: `No problem! We're here to guide you. By utilizing the information you provide and analyzing market dynamics, including comparable homes in your area, we'll present you with a first look at your home's rental\u00a0value.`,
    expectedRent: 'Expected Rent ($/mo.)',
    previous: 'Previous',
    cta: 'Next',
  },
  condition: {
    label: 'Condition',
    question: `Let's get started! When was the last major renovation of this\u00a0home?`,
    pastYear: 'Past Year',
    oneThreeYears: '1-3 Years',
    threeFiveYears: '3-5 Years',
    plusFiveYears: '5+ Years',
    info: {
      PastYear: `Excellent! You've put a lot of love into this home—prospective residents will surely take notice! The recent upgrades should elevate demand and contribute to a higher rental value for your\u00a0home.`,
      OneToThree:
        'Great! With a renovation in the last 1-3 years, your home maintains a fresh and contemporary feel, appealing to residents who value modern\u00a0comforts.',
      ThreeToFive:
        'Solid! A renovation within the past 3-5 years strikes a balance between modernity and lived-in comfort, making your home an attractive option\u00a0for\u00a0many.',
      MoreThanFive: `Although it's been a while since the last major renovation, this can speak to the enduring quality of your home, attracting those who appreciate classic\u00a0features.`,
    },
    previous: 'Previous',
    cta: 'Next',
  },
  pets: {
    label: 'Pets',
    question: 'Will you be welcoming pets into your rental\u00a0home?',
    infoYes: `Great to hear that your property is pet-friendly! This can be a significant draw for many renters and might positively impact your rental's appeal and demand in the\u00a0market!`,
    infoNo:
      'Understood. A pet-free home caters to those valuing an allergen-free environment. While this might limit demand slightly, it ensures a pristine living\u00a0space.',
    yes: 'Yes',
    no: 'No',
    previous: 'Previous',
    cta: 'Next',
  },
  primaryMaterial: {
    label: 'Material',
    question: 'Could you tell us about the primary material of the kitchen appliances in your\u00a0home?',
    info: {
      StainlessSteel: `Excellent! Stainless steel appliances add a modern touch, enhancing the overall appeal of your kitchen and potentially boosting the rental\u00a0value.`,
      ColoredFinish: `Understood. Colored finish, like black or white is standard. We'll evaluate its impact neutrally on your home's rental\u00a0value.`,
      CustomFinish: `Great! Custom finishes can set your kitchen apart, adding a unique touch that may positively influence the rental value of your\u00a0home.`,
    },
    stainlessSteel: 'Stainless Steel',
    coloredFinish: 'Colored Finish',
    customFinish: 'Custom Finish',
    previous: 'Previous',
    cta: 'Next',
  },
  features: {
    label: 'Features',
    question: 'Are there any additional features your home has to\u00a0offer?',
    options: {
      Pool: 'Pool',
      Laundry: 'In-Home Washer/Dryer',
      'Garage Parking': 'Designated Parking',
      none: 'None of These',
    },
    previous: 'Previous',
    cta: 'Next',
  },
  calculation: {
    label: 'Calculation',
    question: "We're evaluating recent rental trends in {city} to understand local market\u00a0dynamics.",
    login: 'Unlock your rent estimate for\u00a0{address}.',
    questionLogin: 'Let’s continue to your rent\u00a0estimate.',
    cta: 'Next',
    changeAddress: 'Change Address',
  },
  success: {
    bubble: {
      default: `Here's our initial estimate based on current market data. Let's connect to discuss how Belong can ensure a prompt listing and guarantee rent for the entirety of your\u00a0lease.`,
      inLine: `Great news! Our initial estimate aligns with your expected rental income of {value}. Let's  connect to discuss how Belong can ensure a prompt listing and guarantee rent for the entirety of your\u00a0lease.`,
      above: `Our estimate is slightly below your expectation of {value}. No worries! Let's connect to fine-tune our analysis and discuss how Belong can guarantee rent for the entirety of your\u00a0lease.`,
      below: `Exciting news! Our initial estimate, based on current market data, exceeds your expectation of {value}. Book a call now to discuss a more precise estimate and discover how Belong can guarantee rent for the entirety of your\u00a0lease.`,
      noData: `Shoot! We don't have enough data on this home to fetch a rent estimate. Rest assured our experts will gather that now. Book a time that works, and we'll review it\u00a0with\u00a0you.`,
      outOfCoverage: `Here's what we think you're home will rent for based on current market data. BelongX can ensure you never miss\u00a0a\u00a0payment.`,
    },
    wrongInformation: `Something’s off? Schedule\u00a0a\u00a0call`,
    cta: 'Schedule A Call',
    ctaGetStarted: 'Get Started',
    ctaSkip: 'Skip',
    ctaLearnMore: 'Learn More',
    bed: 'Bed',
    beds: 'Beds',
    bath: 'Bath',
    baths: 'Baths',
    fullBath: 'Full Bath',
    fullBaths: 'Full Baths',
    halfBath: 'Half Bath',
    halfBaths: 'Half Baths',
    squareFeetUnit: 'Sq.ft.',
    condition: 'Condition',
    renovation: 'Renovation',
    pets: 'Pets',
    builtIn: 'Built',
    homeownerFeedbackTitle: 'How do you feel about this\u00a0range?',
    seemsLow: 'Seems Low',
    seemsLowDescription:
      "We get it – this estimate might feel a bit on the low side. As a next step, we'll provide a complimentary inspection to uncover all of your home's unique features. This way, we can fine-tune pricing at the sweet spot between top-notch rent and minimal vacancy. Let's make sure your home gets the love it\u00a0deserves.",
    looksRight: 'Looks Right',
    looksRightDescription:
      "We've carefully considered various factors to provide an initial estimate, and now, our team will conduct a complimentary inspection to narrow in on the best list price. Ready for the next\u00a0step?",
    seemsHigh: 'Seems High',
    seemsHighDescription:
      "No problem! We're here to ensure the rental value aligns perfectly with market demand. As a next step, we'll schedule a complimentary inspection to delve into your home's specifics. Let's make sure your home is positioned for\u00a0success!",
    primaryMaterial: 'Primary material',
    features: {
      title: 'Features',
      options: {
        Pool: 'Pool',
        Laundry: 'In-Home Washer/Dryer',
        'Garage Parking': 'Designated Parking',
        none: 'None',
      },
      headerOptions: {
        Pool: 'Pool',
        Laundry: 'Laundry',
        'Garage Parking': 'Parking',
      },
    },
    propertyTypeOptions: {
      SingleFamily: 'Single Family',
      Townhouse: 'Townhouse',
      Condo: 'Condo',
      MultiFamily: 'Multi Family',
      MultiUnit: 'Multi Unit',
    },
    homeConditionOptions: {
      QuiteRundown: 'Quite Rundown',
      NeedsWork: 'Needs Work',
      QuiteAverage: 'Quite Average',
      PrettyGood: 'Pretty Good',
      ShinyPalace: 'Shiny Palace',
    },
    petOptions: {
      yes: 'Pet Friendly',
      no: 'No Pets',
    },
    renovationOptions: {
      PastYear: 'Past Year',
      OneToThree: '1-3 Years Ago',
      ThreeToFive: '3-5 Years Ago',
      MoreThanFive: '5+ Years Ago',
    },
    kitchenPrimaryMaterialOptions: {
      StainlessSteel: 'Stainless Steel',
      ColoredFinish: 'Colored Finish',
      CustomFinish: 'Custom Finish',
    },
    priceRange: {
      month: '/mo.',
      squareFeet: '/ft\u00b2',
      low: 'Rents Faster',
      high: 'Rents Slower',
    },
    comparables: {
      title: 'Nearby Home Rentals',
      myHome: 'MY HOME',
      beds: 'Beds',
      baths: 'Baths',
      price: 'Price/Ft\u00b2',
      daysListed: 'Days Listed',
      overpriced: 'Overpriced',
    },
    info: {
      title: `We're 100% aligned with maximizing your\u00a0earnings!`,
      body: 'Since we only get paid once your home is loved, we are aligned in minimizing vacancy and maximizing your annual\u00a0income.',
    },
  },
};
